<template>
  <div class="full bg fillin">
      <el-form ref="form" size="mini" :model="form" :rules="rules" label-width="70px" class="subformbg" v-if="formvisible">
        <el-col :span="12" :xs="11">
        <el-form-item label="姓名:" prop="name">
          <el-input v-model="form.name" placeholder="请输入您的姓名"></el-input>
        </el-form-item>
        </el-col>
        <el-col :span="12" :xs="11">
        <el-form-item label="年龄:" prop="age">
          <el-input v-model="form.age" placeholder="请输入您的年龄"></el-input>
        </el-form-item>
        </el-col>
        <el-col :span="12" :xs="11">
        <el-form-item label="微信:" prop="wechat">
          <el-input
            v-model="form.wechat"
            placeholder="请输入您的微信号"
          ></el-input>
        </el-form-item>
        </el-col>
        <el-col :span="12" :xs="11">
        <el-form-item label="手机:" prop="mobile">
          <el-input
            v-model="form.mobile"
            placeholder="请输入您的手机号"
            id ="mobile"></el-input>
        </el-form-item>
        </el-col>
        
        <el-col :span="12" :xs="11">
        <el-form-item label="城市:" prop="city">
          <el-input v-model="form.city" placeholder="请输入您的常住城市" id="city"></el-input>
        </el-form-item>
        </el-col>
        <el-col :span="12" :xs="11">
        <el-form-item label="区/县:" prop="xian">
          <el-input v-model="form.xian" placeholder="请输入您的所在区县"></el-input>
        </el-form-item>
        </el-col>
        
        <el-col :span="12" :xs="11">
        <el-form-item label="职业:" prop="job">
          <el-input v-model="form.job" placeholder="请输入您的工作"></el-input>
        </el-form-item>
        </el-col>
        <el-col :span="12" :xs="11">
        <el-form-item label="收入:" prop="income">
          <el-input
            v-model="form.income"
            placeholder="请输入您的年收入"
          ></el-input>
        </el-form-item>
        </el-col>
        <div class="center" style="text-align:center;">
          <el-button type="primary" @click="validate('form')" class="" id="submitBtn"
            >确定</el-button>
        </div>
      </el-form>
      
      <div class="center endinfo" id="end" v-show="!formvisible">
      </div>
      <div style="text-align:center;" v-show="goBackBtnVisible">
        <img src="../assets/images/gooutWithhands.jpg" width="50%" height="25%"/>
        <br/>
        <button @click="goBack()">游戏结束</button>
      </div>
      <audio controls="controls"   ref='audio' style="display:none" autoplay>
        <source  :src="musicUrl"  type="audio/mpeg">
      </audio>
    </div> 
</template>
<script>
  var click_mr1=false;//男生第一次点击提交按钮标志
  var click_mr2=false;//男生第二次点击提交按钮标志
  var click_mis1=false;//女生第一次点击提交按钮标志
  var click_mis2=false;//女生第二次点击提交按钮标志

import axios from "axios";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

export default {

  data() {
    return {
      form: {
        name: "",
        age: "",
        job: "",
        city: "",
        xian: "",
        mobile: "",
        wechat: "",
        income:"",
        deviceid: "",
      },
      citys: [
        {
          value: "nanjing",
          label: "南京市",
        },
      ],
      xianlist: [
        {
          value: "jianye",
          label: "建邺区",
        },
      ],
      musicUrl:require("@/assets/sounds/firstshuaige.mp3"),
      sex:'',
      rules: {
          name: [
            { required: true, message: '请输入姓名', trigger: 'blur' },
          ],
          age: [
            { required: true, message: '请输入年龄', trigger: 'blur' },
          ],
          job: [
            { required: true, message: '请输入您的工作', trigger: 'blur' },
          ],
          city: [
            { required: true, message: '请输入您的常住城市', trigger: 'blur' },
          ],
          xian: [
            { required: true, message: ' ', trigger: 'blur' },
          ],
          mobile: [
            { required: true, message: '请输入您的手机号', trigger: 'blur' },
            { min: 11, max: 11, message: '请输入正确的手机号码', trigger: 'blur'}
          ],
          wechat: [
            { required: true, message: '请输入您的微信号', trigger: 'blur' },
          ],
          income: [
            { required: true, message: '请输入您的收入', trigger: 'blur' },
          ],

        },
        formvisible:false,
        goBackBtnVisible:false
    };
  },
  methods: {
    async onload(){
      const fp = await FingerprintJS.load();
      const result = await fp.get();
    
      // This is the visitor identifier:
      this.form.deviceid = result.visitorId;
    },
    validate(params){
      var city = document.getElementById('city');
      if(city.value=="")
      {
        alert('请填写常驻城市');
        return;
      }
      var mobile =  document.getElementById('mobile');
       if(mobile.value=="")
      {
        alert('请填写您的手机号码');
        return;
      }
      this.$refs[params].validate((valid) => {
          if (valid) {
                  if(!click_mr1)
                  {
                    click_mr1=true;
                    //请示美女拍照
                    this.musicUrl = require("@/assets/sounds/请美女拍照.mp3")
                    this.$refs.audio.load();
                    this.$refs.audio.play();
                    document.getElementById('submitBtn').innerHTML="拍照完毕后，请点击";
                    return;
                  }
                  if(click_mr1 && !click_mr2)
                  {
                    click_mr2=true;
                    this.submit(this.form);
                    document.getElementById('submitBtn').innerHTML="确定";
                    return;
                  }
                  if(click_mr1 && click_mr2 && !click_mis1)
                  {
                    click_mis1=true; 
                    //请示美女拍照
                    this.musicUrl = require("@/assets/sounds/请帅哥拍照.mp3")
                    this.$refs.audio.load();
                    this.$refs.audio.play();
                    document.getElementById('submitBtn').innerHTML="拍照完毕后，请点击";
                    return;
                  }
                  if(click_mr1 && click_mr2 && click_mis1 && !click_mis2)
                  {
                    click_mis2=true;
                    this.submit(this.form);
                    document.getElementById('submitBtn').innerHTML="确定";
                    return;
                  }
                  
            //this.submit(this.form);
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    }, 
    // autoPlay(id,src){
    //   var  audio = document.getElementById(id);
    //   audio.src = src;
    //   audio.play();
    //   document.addEventListener( "WeixinJSBridgeReady" ,  function  () {
    //          audio.play();
    //  },  false );
    // },
    async submit(params) {
      params.age = parseInt(params.age);
      let result = {}
      const res = await axios
        .get("http://gameserver.9help.net/ManageCenter/SubmitMember", {
          params,
        })
        .then(function (res) {
          const { data } = res;
          result = data
        })
        .catch(function (err) {
          console.log(err);
        });
        if (result.code == 0) {
            if(this.sex == 'miss' && click_mr1 && click_mr2 && click_mis1 && click_mis2){
                  click_mr1=click_mr2=click_mis1=click_mis2=false;
                  this.formvisible = false;
                  this.end()
                }else{
                  this.sex = 'miss';
                  this.$refs["form"].resetFields();
                  this.musicUrl = require("@/assets/sounds/请美女填写1.mp3")
                  this.$refs.audio.load();
                  this.$refs.audio.play()
                }
          }
          else{
            this.$message({
              showClose: true,
              message: '提交失败，请重新提交！',
              type: 'warning'
            });
          }
    },
    start(){
      let tmplist = [
        {
          con:'<div style="margin-left:10px;">请你们双方向对方介绍自己</div>',
          sound:require("@/assets/sounds/先请帅哥填写自己的姓名电话等内容1.mp3")
        },
        {
          con:'<div style="margin-left:10px;">先请帅哥填写自己的姓名电话等内容,请美女准备拍照帅哥的身份信息并珍藏</div>',
          sound:require("@/assets/sounds/先请帅哥填写自己的姓名电话等内容2.mp3")
        }
      ];
      let end = document.getElementById('end');
      end.innerHTML = tmplist[0].con;
      this.musicUrl = tmplist[0].sound;
      // this.$refs.audio.load();
      // this.$refs.audio.play();
      var audio_start1 = new Audio(tmplist[0].sound);
      audio_start1.play();
      setTimeout(()=>{
        end.innerHTML = tmplist[1].con;
        this.musicUrl = tmplist[1].sound;
        // this.$refs.audio.load();
        // this.$refs.audio.play();
        var audio_start2 = new Audio(tmplist[1].sound);
        audio_start2.play();
        setTimeout(()=>{
          this.formvisible =true;
        },9500);
      },4500)
      this.formvisible = false;
    },
    end(){
      let endlist = [
        {
          con:'<div style="text-align:center;">恭喜你们游戏结束了！</div>',
          sound:require("@/assets/sounds/恭喜你们游戏结束了.mp3")
        },
        {
          con:'<div style="text-align:center;"><p style="margin-top:-150px;">此&nbsp;&nbsp;时</p><p style="margin-top:5px;">请帅哥体贴地</p><p style="margin-top:5px;">牵着美女的手</p><p style="margin-top:5px;">一起走出去</p></div>',
          sound:require("@/assets/sounds/一起走出去.mp3")
        }
      ];
      let end = document.getElementById('end');
      end.innerHTML = endlist[0].con;
      this.musicUrl = endlist[0].sound;
      this.$refs.audio.load();
      this.$refs.audio.play()
      setTimeout(()=>{
        end.innerHTML = endlist[1].con;
        this.musicUrl = endlist[1].sound;
        this.$refs.audio.load();
        this.$refs.audio.play()
        this.goBackBtnVisible=true;
      },3500)
    },
    goBack(){
      this.$router.push({ path: "/" });
    }
  },
  mounted(){
        this.onload();
        this.start();  
  }
};
</script>

